import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';

const NewDetailBox = styled.span`
  font-weight: bold;
  color: #10ce64;
  margin-right: 5px;
  text-transform: uppercase;
  display: inline-block;
`;

const NewDetail = ({ value }) => (
  <NewDetailBox>
    {value}
  </NewDetailBox>
);

NewDetail.propTypes = {
  value: string,
};

NewDetail.defaultProps = {
  value: 'Novo',
};

export default NewDetail;
